import React from "react";
import { InputGroup, InputGroupText, InputGroupAddon, Input } from "reactstrap";
import { oneOfType, string, number, func, bool } from "prop-types";

function LimitInput({ currency, value, onChange, invalid }) {
  const onKeyPress = e => {
    const keys = ["e", "E", ",", "."];

    if (keys.includes(e.key)) {
      e.preventDefault();
    }
  };

  const onInput = e => {
    e.target.value = parseInt(e.target.value);

    onChange(e);
  };

  return (
    <InputGroup className="input-prepend">
      <InputGroupAddon addonType="prepend">
        <InputGroupText style={{ width: 33 }}>
          {getCurrencySymbol(currency)}
        </InputGroupText>
      </InputGroupAddon>
      <Input
        type="number"
        name={currency}
        value={value}
        onKeyPress={onKeyPress}
        onChange={onInput}
        style={{
          textAlign: "right",
          alignSelf: "stretch",
        }}
        invalid={invalid}
      />
      <InputGroupAddon addonType="append">
        <InputGroupText>.00</InputGroupText>
      </InputGroupAddon>
    </InputGroup>
  );
}

const getCurrencySymbol = currency => {
  switch (currency) {
    default:
    case "USD":
      return "$";
    case "KHR":
      return "៛";
  }
};

LimitInput.propTypes = {
  currency: string.isRequired,
  value: oneOfType([string, number]).isRequired,
  onChange: func.isRequired,
  invalid: bool,
};

LimitInput.defaultProps = {
  currency: "USD",
  value: 0,
  onChange: () => {},
  invalid: false,
};

export default LimitInput;
